import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  Badge,
  Spinner,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  Form,
  Input,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";
import "./table.css";

import optionsIcon from "../../assets/tables/optionsIcon.svg";
import printerIcon from "../../assets/tables/printerIcon.svg";
import TulufaliLogo from "../../components/Icons/tulufali_logo.png";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

import s from "./Tables.module.scss";

import {
  API_TIMEOUT,
  LOKASI,
  NERACA,
  NERACA_GUDANG_DETAIL,
  NERACA_PUSKESMAS_DETAIL,
} from "../../utils/index.js";
import axios from "axios";

import { useDispatch } from "react-redux";

import Success from "../../assets/success.png";
import { logApp, numberWithCommas } from "../../utils/func.js";
import Select, { components } from "react-select";
import swal from "sweetalert";

const TableNeracaMasukGudang_Gudang = function () {
  const [firstTable, setFirstTable] = useState([]);
  const [secondTable, setSecondTable] = useState([]);
  const [lokasi, setLokasi] = useState("");
  const [level, setLevel] = useState("");
  const [puskesmas, setPuskesmas] = useState("");
  const [unit, setUnit] = useState("");

  const [firstTableCurrentPage, setFirstTableCurrentPage] = useState(0);
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0);

  const [modalDelete, setModalDelete] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [detailData, setDetailData] = useState([]);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const today = new Date();
  const currentYear = today.getFullYear();
  const [simpleDropdownValue2, setSimpleDropdownValue2] = useState(
    currentYear.toString()
  );
  const [bantuanModal, setBantuanModal] = useState("");
  const [tahun, setTahun] = useState(currentYear.toString());

  // tanggal awal & akhir untuk filter neraca gudang (default: 1 Jan s.d hari ini)
  const defaultTanggalAwal = `${currentYear}-01-01`;
  const defaultTanggalAkhir = today.toISOString().split("T")[0];
  const [tanggalAwal, setTanggalAwal] = useState(defaultTanggalAwal);
  const [tanggalAkhir, setTanggalAkhir] = useState(defaultTanggalAkhir);
  const [maxTanggalAkhir, setMaxTanggalAkhir] = useState(defaultTanggalAkhir);
  const [dataLoaded, setDataLoaded] = useState(false);

  const [idLok2, setIdLok2] = useState([{ value: 1, label: "Gudang" }]);

  const [modalSK, setModalSk] = useState(false);
  const [idKunci, setIdKunci] = useState("");

  const [currentUser, setCurrentUser] = useState();
  const [idLokasi, setIdLokasi] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!currentUser) {
      const currentUser = JSON.parse(localStorage.getItem("user"));
      setCurrentUser(currentUser);
      logApp(currentUser.uid, "Neraca Obat Gudang");
      setIdLokasi(currentUser.idLokasi);
    }
  }, []);

  const containerStyle = {
    width: "100%",
    height: "300px", // Atur tinggi sesuai kebutuhan Anda
    overflow: "auto",
    /* Gaya tampilan scroll */
    scrollbarWidth: "thin",
    scrollbarColor: "#888888 #f0f0f0",
  };

  useEffect(() => {
    if (idLokasi) {
      ambilDataLokasi();
      // Data tidak dimuat otomatis, user harus klik tombol Cari terlebih dahulu
    }
  }, [idLokasi]);

  // Deteksi perubahan pada filter untuk mengaktifkan kembali tombol Cari
  useEffect(() => {
    if (dataLoaded) {
      setDataLoaded(false);
    }
  }, [tanggalAwal, tanggalAkhir, tahun, idLok2]);

  const ambilDataLokasi = () => {
    axios({
      method: "get",
      url: LOKASI + "ambil/",
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;
          if (data.length > 0) {
            const datafilter = data.filter((item) => {
              // Filter level dan hindari duplikasi "Gudang" (id=1 atau label="Gudang")
              return (
                (item.level == "Puskesmas" || item.level == "Dinas") &&
                item.id != 1 &&
                item.lokasi != "Gudang"
              );
            });
            let lok = [];
            // Tambahkan "Gudang" sebagai opsi pertama dengan value 1
            lok.push({
              value: 1,
              label: "Gudang",
              color: "primary",
            });
            for (var i = 0; i < datafilter.length; i++) {
              lok.push({
                value: datafilter[i].id,
                label: datafilter[i].lokasi,
                color: "primary",
              });
            }

            setLokasi(lok);

            setLevel("Dinas");
          }
        }
      })
      .catch((error) => {
        // ERROR

        alert(error);
      });
  };

  const ambilNeraca = (id) => {
    setLoading(true);
    axios({
      method: "get",
      url: NERACA + "puskesmas/" + id + "/range",
      params: {
        tanggal_awal: tanggalAwal,
        tanggal_akhir: tanggalAkhir,
      },
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          setLoading(false);
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;

          setFirstTable(data);
          setLoading(false);
          setDataLoaded(true);
        }
      })
      .catch((error) => {
        // ERROR
        setLoading(false);
        setDataLoaded(false);
        alert(error);
      });
  };

  const ambilNeracaGudang = () => {
    setLoading(true);
    axios({
      method: "get",
      url: NERACA + "gudang/range",
      params: {
        tanggal_awal: tanggalAwal,
        tanggal_akhir: tanggalAkhir,
      },
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          setLoading(false);
          setDataLoaded(false);
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;

          setFirstTable(data);
          setLoading(false);
          setDataLoaded(true);
        }
      })
      .catch((error) => {
        // ERROR
        setLoading(false);
        setDataLoaded(false);
        alert(error);
      });
  };

  const listTahun = [];
  for (let tahun = 2024; tahun <= currentYear; tahun++) {
    listTahun.push({ tahun: tahun });
  }

  const changeSelectDropdownSimple2 = (e) => {
    const select = e.currentTarget.textContent;
    setSimpleDropdownValue2(e.currentTarget.textContent);
    const curAnak = listTahun.filter((item) => {
      return item.tahun == select;
    });

    const selectedYear = parseInt(curAnak[0].tahun);
    setTahun(selectedYear.toString());

    // Atur tanggal awal dan akhir berdasarkan tahun yang dipilih
    if (selectedYear === currentYear) {
      // Jika tahun yang dipilih adalah tahun ini
      // Tanggal awal: 1 Januari tahun ini
      // Tanggal akhir: tanggal hari ini
      const tanggalAwalBaru = `${currentYear}-01-01`;
      const tanggalAkhirBaru = today.toISOString().split("T")[0];
      setTanggalAwal(tanggalAwalBaru);
      setTanggalAkhir(tanggalAkhirBaru);
      setMaxTanggalAkhir(tanggalAkhirBaru); // Max date adalah hari ini
    } else {
      // Jika tahun yang dipilih adalah tahun sebelumnya
      // Tanggal awal: 1 Januari tahun yang dipilih
      // Tanggal akhir: 31 Desember tahun yang dipilih
      const tanggalAwalBaru = `${selectedYear}-01-01`;
      const tanggalAkhirBaru = `${selectedYear}-12-31`;
      setTanggalAwal(tanggalAwalBaru);
      setTanggalAkhir(tanggalAkhirBaru);
      setMaxTanggalAkhir(tanggalAkhirBaru); // Max date adalah 31 Desember tahun yang dipilih
    }
    // ambilDataBantuanKategori(currentBantuan, curAnak[0].tahun);
  };

  const OptionComponent = ({ data, ...props }) => {
    return (
      <components.Option {...props}>
        <div className={`bullet bullet-${data.color} bullet-sm mr-2`}></div>
        {data.label}
      </components.Option>
    );
  };

  const pageSize = 100;
  const pageSize2 = 100;
  const firstTablePagesCount = Math.ceil(firstTable.length / pageSize);
  const secondTablePagesCount = Math.ceil(secondTable.length / pageSize2);

  const setFirstTablePage = (e, index) => {
    e.preventDefault();
    setFirstTableCurrentPage(index);
  };

  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  };

  const openModal = (data) => {
    setModalDelete(true);
  };
  const closeModal = () => {
    setModalDelete(false);
  };

  const openModalDetail = (item) => {
    setSelectedItem(item);
    setModalDetail(true);
    ambilDetailMasukGudang(item);
  };

  const closeModalDetail = () => {
    setModalDetail(false);
    setDetailData([]);
    setSelectedItem(null);
  };

  const ambilDetailMasukGudang = (item) => {
    if (!item || !item.id_dataObat) {
      swal("Error", "Data tidak valid", "error");
      return;
    }

    // Tentukan endpoint berdasarkan level (gudang atau puskesmas)
    const isGudang =
      idLok2 &&
      Array.isArray(idLok2) &&
      idLok2.length > 0 &&
      idLok2[0] &&
      idLok2[0].value == 1;

    const endpoint = isGudang ? NERACA_GUDANG_DETAIL : NERACA_PUSKESMAS_DETAIL;

    const params = isGudang
      ? {
          id_dataObat: item.id_dataObat,
          sumber: item.sumber,
          subsumber: item.subsumber,
          tahunPengadaan: item.tahunPengadaan,
          harga: item.harga,
          tanggal_awal: tanggalAwal,
          tanggal_akhir: tanggalAkhir,
        }
      : {
          id_lokasi:
            idLok2 &&
            Array.isArray(idLok2) &&
            idLok2.length > 0 &&
            idLok2[0] &&
            idLok2[0].value
              ? idLok2[0].value
              : idLokasi,
          id_dataObat: item.id_dataObat,
          sumber: item.sumber,
          subsumber: item.subsumber,
          tahunPengadaan: item.tahunPengadaan,
          harga: item.harga,
          tanggal_awal: tanggalAwal,
          tanggal_akhir: tanggalAkhir,
        };

    setLoadingDetail(true);
    axios({
      method: "get",
      url: endpoint,
      params: params,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          setLoadingDetail(false);
          return "error";
        } else {
          const data = response.data.data;
          setDetailData(data);
          setLoadingDetail(false);
        }
      })
      .catch((error) => {
        setLoadingDetail(false);
        swal("Error", error.message || "Gagal mengambil data detail", "error");
      });
  };

  const openModalSk = (data) => {
    //ambilDataBantuanTahun(data);
    setModalSk(true);
  };
  const closeModalSk = () => {
    setModalSk(false);
  };

  const onChangeLokasi = (data) => {
    setIdLok2([data]);
    setDataLoaded(false); // Reset dataLoaded saat lokasi berubah agar tombol Cari aktif kembali
    // Data tidak langsung dimuat, user harus klik tombol Cari terlebih dahulu
  };

  const getFileName = () => {
    const now = new Date();
    const tanggal = now.toISOString().split("T")[0].replace(/-/g, ""); // Format: YYYYMMDD
    let lokasiNama = "Gudang";

    if (
      idLok2 &&
      Array.isArray(idLok2) &&
      idLok2.length > 0 &&
      idLok2[0] &&
      idLok2[0].label
    ) {
      lokasiNama = idLok2[0].label.replace(/[^a-zA-Z0-9]/g, "_");
    } else if (idLok2 && typeof idLok2 === "string" && idLok2 !== "") {
      lokasiNama = idLok2.replace(/[^a-zA-Z0-9]/g, "_");
    }

    return `Neraca_${lokasiNama}_${tahun}_${tanggal}`;
  };

  // Fungsi helper untuk format tanggal Indonesia
  const formatTanggalIndonesia = (tanggalString) => {
    if (!tanggalString) return "";
    try {
      const [tahun, bulan, hari] = tanggalString.split("-");
      const namaBulan = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];
      return `${parseInt(hari)} ${namaBulan[parseInt(bulan) - 1]} ${tahun}`;
    } catch (error) {
      return tanggalString;
    }
  };

  const exportToExcel = () => {
    const table = document.getElementById("neraca");
    if (!table) {
      swal("Error", "Tabel tidak ditemukan", "error");
      return;
    }

    const wb = XLSX.utils.table_to_book(table, { sheet: "Data" });
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, getFileName() + ".xlsx");
  };

  // Fungsi helper untuk menghitung persentase penggunaan
  const calculateUsagePercentage = (keluar, masuk) => {
    if (!masuk || masuk === 0 || isNaN(masuk) || !isFinite(masuk)) {
      return 0;
    }
    if (!keluar || isNaN(keluar) || !isFinite(keluar)) {
      return 0;
    }
    const percentage = (keluar / masuk) * 100;
    return isNaN(percentage) || !isFinite(percentage)
      ? 0
      : Math.max(0, Math.min(100, percentage));
  };

  const exportToPDF = () => {
    const table = document.getElementById("neraca");
    if (!table) {
      swal("Error", "Tabel tidak ditemukan", "error");
      return;
    }

    const doc = new jsPDF();
    doc.text("Laporan Neraca Gudang", 14, 15);
    doc.text(`Tahun: ${tahun}`, 14, 22);

    const tableData = [];
    const headers = [];

    // Ambil headers
    const thead = table.querySelector("thead");
    if (thead) {
      const headerRows = thead.querySelectorAll("tr");
      headerRows.forEach((row) => {
        const rowData = [];
        row.querySelectorAll("th").forEach((th) => {
          const text = th.textContent.trim();
          if (text) {
            rowData.push(text);
          }
        });
        if (rowData.length > 0) {
          headers.push(rowData);
        }
      });
    }

    // Ambil data
    const tbody = table.querySelector("tbody");
    if (tbody) {
      tbody.querySelectorAll("tr").forEach((row) => {
        const rowData = [];
        row.querySelectorAll("td").forEach((td) => {
          const text = td.textContent.trim();
          rowData.push(text);
        });
        if (rowData.length > 0) {
          tableData.push(rowData);
        }
      });
    }

    if (headers.length > 0 && tableData.length > 0) {
      doc.autoTable({
        head: headers,
        body: tableData,
        startY: 30,
        styles: { fontSize: 7 },
        headStyles: { fillColor: [66, 139, 202] },
      });
    }

    doc.save(getFileName() + ".pdf");
  };

  return (
    <div>
      <Row>
        <Col>
          {/* Widget dengan Filter dan Tabel dalam 1 Blok */}
              <Widget>
                <div className={s.tableTitle}>
                  <div className="headline-2">
                Laporan Neraca #
                {idLok2 &&
                  Array.isArray(idLok2) &&
                  idLok2.length > 0 &&
                  idLok2[0] &&
                  idLok2[0].label && <code> {idLok2[0].label}</code>}
                {tanggalAwal && tanggalAkhir && (
                  <>
                    {" | "}
                    <span style={{ fontSize: "0.9em", fontWeight: "normal" }}>
                      {formatTanggalIndonesia(tanggalAwal)} -{" "}
                      {formatTanggalIndonesia(tanggalAkhir)}
                    </span>
                  </>
                )}
                    </div>
                  </div>

            {/* Form Filter Controls */}
            <div style={{ padding: "1rem", borderBottom: "1px solid #dee2e6" }}>
              <Form>
                <Row className="align-items-end">
                  {/* Pilih Lokasi Obat */}
                  <Col md={3} className="mb-2">
                    <FormGroup className="mb-0">
                      <Label
                        for="label"
                        className="mb-1"
                        style={{ fontSize: "0.875rem", fontWeight: "500" }}
                      >
                        Lokasi Obat
                      </Label>
                    <Select
                      id="label"
                      value={idLok2}
                      options={lokasi}
                      className="react-select"
                      classNamePrefix="select"
                      isClearable={false}
                      onChange={(data) => {
                        onChangeLokasi(data);
                      }}
                        placeholder="Pilih lokasi..."
                    />
                  </FormGroup>
                  </Col>

                  {/* Tahun */}
                  <Col
                    md={1}
                    className="mb-2"
                    style={{ flex: "0 0 12%", maxWidth: "12%" }}
                  >
                    <FormGroup className="mb-0">
                      <Label
                        className="mb-1"
                        style={{ fontSize: "0.875rem", fontWeight: "500" }}
                      >
                        Tahun
                      </Label>
                      <UncontrolledButtonDropdown className="w-100">
                        <DropdownToggle
                          caret
                          color="primary"
                          size="sm"
                          className="w-100 text-left"
                          style={{
                            fontSize: "0.8rem",
                            padding: "0.25rem 0.5rem",
                            paddingRight: "1.5rem",
                            position: "relative",
                            overflow: "visible",
                          }}
                        >
                          {simpleDropdownValue2}
                        </DropdownToggle>
                        <DropdownMenu>
                          {listTahun &&
                            listTahun.map((item, idx) => (
                              <DropdownItem
                                key={idx}
                                onClick={changeSelectDropdownSimple2}
                              >
                                {item.tahun}
                              </DropdownItem>
                            ))}
                        </DropdownMenu>
                      </UncontrolledButtonDropdown>
                    </FormGroup>
                    </Col>

                  {/* Tanggal Awal */}
                  <Col md={2} className="mb-2">
                    <FormGroup className="mb-0">
                      <Label
                        for="tanggalAwal"
                        className="mb-1"
                        style={{ fontSize: "0.875rem", fontWeight: "500" }}
                      >
                        Tanggal Awal
                      </Label>
                        <Input
                          id="tanggalAwal"
                          type="date"
                          value={tanggalAwal}
                          onChange={(e) => setTanggalAwal(e.target.value)}
                        bsSize="sm"
                        />
                      </FormGroup>
                    </Col>

                  {/* Tanggal Akhir */}
                  <Col md={2} className="mb-2">
                    <FormGroup className="mb-0">
                      <Label
                        for="tanggalAkhir"
                        className="mb-1"
                        style={{ fontSize: "0.875rem", fontWeight: "500" }}
                      >
                        Tanggal Akhir
                      </Label>
                        <Input
                          id="tanggalAkhir"
                          type="date"
                          value={tanggalAkhir}
                        max={maxTanggalAkhir}
                          onChange={(e) => setTanggalAkhir(e.target.value)}
                        bsSize="sm"
                        />
                      </FormGroup>
                    </Col>

                  {/* Tombol Tampilkan Neraca */}
                  <Col
                    md={1}
                    className="mb-2"
                    style={{ flex: "0 0 12%", maxWidth: "12%" }}
                  >
                    <FormGroup className="mb-0">
                      <Button
                        color="primary"
                        size="sm"
                        className="btnKu w-100"
                        disabled={dataLoaded}
                        style={{
                          fontSize: "0.8rem",
                          padding: "0.25rem 0.5rem",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => {
                          if (
                            idLok2 &&
                            Array.isArray(idLok2) &&
                            idLok2.length > 0 &&
                            idLok2[0] &&
                            idLok2[0].value == 1
                          ) {
                            ambilNeracaGudang();
                          } else if (
                            idLok2 &&
                            Array.isArray(idLok2) &&
                            idLok2.length > 0 &&
                            idLok2[0] &&
                            idLok2[0].value
                          ) {
                            ambilNeraca(idLok2[0].value);
                          } else {
                            ambilNeracaGudang();
                          }
                        }}
                      >
                        <i className="fa fa-search mr-1" />
                        Cari
                      </Button>
                    </FormGroup>
                    </Col>

                  {/* Tombol Export */}
                  <Col
                    md={1}
                    className="mb-2"
                    style={{ flex: "0 0 12%", maxWidth: "12%" }}
                  >
                    <FormGroup className="mb-0">
                      <UncontrolledButtonDropdown
                        className="w-100"
                        style={{
                          display: "block",
                          position: "relative",
                        }}
                      >
                        <DropdownToggle
                          caret
                          color="secondary"
                          size="sm"
                          className="w-100"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingRight: "1.5rem",
                            position: "relative",
                            overflow: "visible",
                          }}
                        >
                          <i className="fa fa-download" />
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={exportToExcel}>
                            <i className="fa fa-file-excel-o mr-2 text-success" />
                            Export Excel
                          </DropdownItem>
                          <DropdownItem onClick={exportToPDF}>
                            <i className="fa fa-file-pdf-o mr-2 text-danger" />
                            Export PDF
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledButtonDropdown>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
                  </div>

            {/* Tabel */}
                <div className="widget-table-overflow">
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ minHeight: "200px" }}
                    >
                      <Spinner color="primary" />
                      <span className="ml-3">Memuat data...</span>
                    </div>
                  ) : (
                    <>
                      <Table
                        className={`table-striped table-borderless table-hover ${s.statesTable}`}
                        id="neraca"
                        responsive
                      >
                        <thead>
                          <tr>
                            <th className={s.checkboxCol}>
                              <div className="checkbox checkbox-primary">
                                <input
                                  className="styled"
                                  id="checkbox100"
                                  type="checkbox"
                                />
                                <label for="checkbox100" />
                              </div>
                            </th>
                            <th className="w-25">NAMA</th>

                            <th className="w-25">SUMBER</th>
                            <th className="w-25">TAHUN</th>
                            <th className="w-25">HARGA SATUAN</th>
                            <th className="w-25">STOK AWAL jml</th>
                            <th className="w-25">STOK AWAL Harga</th>
                            <th className="w-25">PENERIMAAN jml</th>
                            <th className="w-25">PENERIMAAN harga</th>

                            <th className="w-25">PENGELUARAN jml</th>
                            <th className="w-25">PENGELUARAN harga</th>
                            <th className="w-25">STOK jml</th>
                            <th className="w-25">STOK harga</th>
                            <th className="w-25">EXPIRED jml</th>
                            <th className="w-25">EXPIRED harga</th>
                          </tr>
                        </thead>
                        <tbody>
                          {firstTable
                            .slice(
                              firstTableCurrentPage * pageSize,
                              (firstTableCurrentPage + 1) * pageSize
                            )
                            .map((item, index) => (
                              <tr key={uuidv4()}>
                                <td>
                                  <div className="checkbox checkbox-primary">
                                    <input
                                      id={index}
                                      className="styled"
                                      type="checkbox"
                                    />
                                    <Label for={index} />
                                  </div>
                                </td>
                                <td className="d-flex align-items-center">
                                  <span className="ml-3">{item.nama}</span>
                                </td>

                                <td>{item.sumber}</td>

                                <td>{item.tahunPengadaan}</td>
                                <td>
                              Rp. {item.harga && numberWithCommas(item.harga)}
                                </td>

                                <td>
                                  {item.stok_awal &&
                                    numberWithCommas(item.stok_awal)}
                                </td>
                                <td>
                                  Rp.{" "}
                                  {item.total_harga_stok_awal &&
                                numberWithCommas(item.total_harga_stok_awal)}
                                </td>
                                <td>
                                  {item.jumlahMasuk
                                    ? numberWithCommas(item.jumlahMasuk)
                                    : item.total_masuk
                                    ? numberWithCommas(item.total_masuk)
                                    : 0}
                                </td>
                                <td>
                                  Rp.
                                  {item.total_harga_masuk &&
                                    numberWithCommas(item.total_harga_masuk)}
                                </td>
                                <td>
                                  {item.total_keluar &&
                                    numberWithCommas(item.total_keluar)}
                                </td>
                                <td>
                                  Rp.
                                  {item.total_harga_keluar &&
                                    numberWithCommas(item.total_harga_keluar)}
                                </td>
                            <td>{item.stok && numberWithCommas(item.stok)}</td>
                                <td>
                                  Rp.
                                  {item.total_harga_ready &&
                                    numberWithCommas(item.total_harga_ready)}
                                </td>

                                <td>
                                  {item.stok_expired &&
                                    numberWithCommas(item.stok_expired)}
                                </td>

                                <td>
                                  Rp.
                                  {item.total_harga_expired &&
                                    numberWithCommas(item.total_harga_expired)}
                                </td>

                                <td>
                                  <Button
                                    className={`${s.controlBtn} mx-2`}
                                    color="primary"
                                    size="xs"
                                    onClick={() => {
                                      openModalDetail(item);
                                    }}
                                  >
                                    Data
                                  </Button>
                                </td>

                                <td>
                              <div className={`d-flex justify-content-between`}>
                                    <div className="d-flex flex-column mt-3">
                                      <div className={s.activity}>
                                        <p className="body-2">
                                          {Math.round(
                                            calculateUsagePercentage(
                                              item.total_harga_keluar,
                                              item.total_harga_masuk
                                            )
                                          )}
                                          % Penggunaan{" "}
                                        </p>
                                      </div>
                                      <Progress
                                        color={
                                          calculateUsagePercentage(
                                            item.total_harga_keluar,
                                            item.total_harga_masuk
                                          ) > 50
                                            ? "success"
                                            : "danger"
                                        }
                                        className="progress-xs"
                                        value={calculateUsagePercentage(
                                          item.total_harga_keluar,
                                          item.total_harga_masuk
                                        )}
                                      />
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                      <Pagination
                        className="pagination-borderless"
                        aria-label="Page navigation example"
                      >
                        <PaginationItem disabled={firstTableCurrentPage <= 0}>
                          <PaginationLink
                            onClick={(e) =>
                              setFirstTablePage(e, firstTableCurrentPage - 1)
                            }
                            previous
                            href="#top"
                          />
                        </PaginationItem>
                        {[...Array(firstTablePagesCount)].map((page, i) => (
                          <PaginationItem
                            active={i === firstTableCurrentPage}
                            key={i}
                          >
                            <PaginationLink
                              onClick={(e) => setFirstTablePage(e, i)}
                              href="#top"
                            >
                              {i + 1}
                            </PaginationLink>
                          </PaginationItem>
                        ))}
                        <PaginationItem
                          disabled={
                            firstTableCurrentPage >= firstTablePagesCount - 1
                          }
                        >
                          <PaginationLink
                            onClick={(e) =>
                              setFirstTablePage(e, firstTableCurrentPage + 1)
                            }
                            next
                            href="#top"
                          />
                        </PaginationItem>
                      </Pagination>
                    </>
                  )}
                </div>
              </Widget>
        </Col>
      </Row>
      <Modal size="lg" isOpen={modalDelete} toggle={() => closeModal()}>
        <ModalHeader toggle={() => closeModal()}>
          <div className={s.tableTitle}>
            <div className="headline-2">
              {bantuanModal}
              <code> Tahun {tahun}</code>
            </div>
            <div className="d-flex">
              <Button
                color="success"
                size="sm"
                onClick={() => {
                  const table = document.getElementById("dataBantuan");
                  if (!table) {
                    swal("Error", "Tabel tidak ditemukan", "error");
                    return;
                  }
                  const wb = XLSX.utils.table_to_book(table, { sheet: "Data" });
                  const excelBuffer = XLSX.write(wb, {
                    bookType: "xlsx",
                    type: "array",
                  });
                  const data = new Blob([excelBuffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  const now = new Date();
                  const tanggal = now
                    .toISOString()
                    .split("T")[0]
                    .replace(/-/g, "");
                  saveAs(
                    data,
                    "TuluFali_Data_Bansos_" +
                      bantuanModal.replace(/[^a-zA-Z0-9]/g, "_") +
                      "_" +
                      tahun +
                      "_" +
                      tanggal +
                      ".xlsx"
                  );
                }}
                className="btnKu"
                style={{ height: "32px", padding: "0.25rem 0.75rem" }}
              >
                <i className="fa fa-file-excel-o mr-2" />
                Excel
              </Button>
              <Button
                color="danger"
                size="sm"
                onClick={() => {
                  const table = document.getElementById("dataBantuan");
                  if (!table) {
                    swal("Error", "Tabel tidak ditemukan", "error");
                    return;
                  }
                  const doc = new jsPDF();
                  doc.text("TuluFali Data Bansos", 14, 15);
                  doc.text(`Tahun: ${tahun}`, 14, 22);

                  const tableData = [];
                  const headers = [];

                  const thead = table.querySelector("thead");
                  if (thead) {
                    const headerRows = thead.querySelectorAll("tr");
                    headerRows.forEach((row) => {
                      const rowData = [];
                      row.querySelectorAll("th").forEach((th) => {
                        const text = th.textContent.trim();
                        if (text) {
                          rowData.push(text);
                        }
                      });
                      if (rowData.length > 0) {
                        headers.push(rowData);
                      }
                    });
                  }

                  const tbody = table.querySelector("tbody");
                  if (tbody) {
                    tbody.querySelectorAll("tr").forEach((row) => {
                      const rowData = [];
                      row.querySelectorAll("td").forEach((td) => {
                        const text = td.textContent.trim();
                        rowData.push(text);
                      });
                      if (rowData.length > 0) {
                        tableData.push(rowData);
                      }
                    });
                  }

                  if (headers.length > 0 && tableData.length > 0) {
                    doc.autoTable({
                      head: headers,
                      body: tableData,
                      startY: 30,
                      styles: { fontSize: 7 },
                      headStyles: { fillColor: [66, 139, 202] },
                    });
                  }

                  const now = new Date();
                  const tanggal = now
                    .toISOString()
                    .split("T")[0]
                    .replace(/-/g, "");
                  doc.save(
                    "TuluFali_Data_Bansos_" +
                      bantuanModal.replace(/[^a-zA-Z0-9]/g, "_") +
                      "_" +
                      tahun +
                      "_" +
                      tanggal +
                      ".pdf"
                  );
                }}
                className="btnKu"
                style={{ height: "32px", padding: "0.25rem 0.75rem" }}
              >
                <i className="fa fa-file-pdf-o mr-2" />
                PDF
              </Button>
              <a>
                <img src={printerIcon} alt="Printer" />
              </a>
              <a>
                <img
                  className="d-none d-sm-block"
                  src={optionsIcon}
                  alt="Options"
                />
              </a>
              <a>
                <img
                  style={{ width: 30, height: 30 }}
                  src={Success}
                  alt="Funnel"
                />
              </a>
            </div>
          </div>
        </ModalHeader>

        <Widget className="widget-p-md">
          <div className="widget-table-overflow">
            <Table
              id="dataBantuan"
              className={`table-striped table-borderless table-hover ${s.statesTable}`}
              responsive
            >
              <thead>
                <tr>
                  <th className="w-15">TL</th>
                  <th className="w-25">Nama</th>
                  <th className="w-25">Kelompok</th>
                  <th className="w-25">NIK</th>
                  <th className="w-25">Status</th>
                  <th className="w-25">Desa</th>

                  <th className="w-25">Kecamatan</th>
                </tr>
              </thead>
              <tbody>
                {secondTable
                  .slice(
                    secondTableCurrentPage * pageSize2,
                    (secondTableCurrentPage + 1) * pageSize2
                  )
                  .map((item) => (
                    <tr key={uuidv4()}>
                      <td className="d-flex align-items-center">
                        <img
                          className={s.image}
                          src={TulufaliLogo}
                          alt="User"
                        />
                        <span className="ml-3">{item.name}</span>
                      </td>

                      <td>{item.nama}</td>
                      <td>{item.kelompok}</td>
                      <td>{item.nik}</td>
                      <td>
                        <code>
                          {item.idKeluarga != ""
                            ? " miskin ekstrim "
                            : " mampu "}
                        </code>
                      </td>
                      <td>{item.desa}</td>
                      <td>{item.kecamatan}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
            <Pagination
              className="pagination-borderless"
              aria-label="Page navigation example"
            >
              <PaginationItem disabled={secondTableCurrentPage <= 0}>
                <PaginationLink
                  onClick={(e) =>
                    setSecondTablePage(e, secondTableCurrentPage - 1)
                  }
                  previous
                  href="#top"
                />
              </PaginationItem>
              {[...Array(secondTablePagesCount)].map((page, i) => (
                <PaginationItem active={i === secondTableCurrentPage} key={i}>
                  <PaginationLink
                    onClick={(e) => setSecondTablePage(e, i)}
                    href="#top"
                  >
                    {i + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}
              <PaginationItem
                disabled={secondTableCurrentPage >= secondTablePagesCount - 1}
              >
                <PaginationLink
                  onClick={(e) =>
                    setFirstTablePage(e, secondTableCurrentPage + 1)
                  }
                  next
                  href="#top"
                />
              </PaginationItem>
            </Pagination>
          </div>
        </Widget>
      </Modal>

      {/* Modal Detail Masuk Gudang */}
      <Modal size="lg" isOpen={modalDetail} toggle={() => closeModalDetail()}>
        <ModalHeader toggle={() => closeModalDetail()}>
          <div className={s.tableTitle}>
            <div className="headline-2">
              Detail Obat Masuk Gudang
              {selectedItem && (
                <code>
                  {" "}
                  - {selectedItem.nama} ({selectedItem.sumber},{" "}
                  {selectedItem.tahunPengadaan})
                </code>
              )}
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          {loadingDetail ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <Spinner color="primary" />
              <span className="ml-3">Memuat data detail...</span>
            </div>
          ) : detailData.length === 0 ? (
            <div className="text-center py-5">
              <p className="text-muted">Tidak ada data detail</p>
            </div>
          ) : (
            <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
              {detailData.map((item, index) => (
                <Card
                  key={uuidv4()}
                  className="mb-3"
                  style={{
                    borderLeft: "4px solid #007bff",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  <CardHeader
                    style={{
                      backgroundColor: "#f8f9fa",
                      padding: "0.75rem 1rem",
                      borderBottom: "1px solid #dee2e6",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <strong>
                        #{index + 1} - {item.nama_obat || "N/A"}
                      </strong>
                      <Badge color="info">
                        {item.tanggalMasuk
                          ? new Date(item.tanggalMasuk).toLocaleDateString(
                              "id-ID"
                            )
                          : "-"}
                      </Badge>
                    </div>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col md={6} className="mb-2">
                        <div className="d-flex">
                          <strong
                            className="mr-2"
                            style={{ minWidth: "140px" }}
                          >
                            No Faktur:
                          </strong>
                          <span>{item.noFaktur || "-"}</span>
                        </div>
                      </Col>
                      <Col md={6} className="mb-2">
                        <div className="d-flex">
                          <strong
                            className="mr-2"
                            style={{ minWidth: "140px" }}
                          >
                            No Registrasi:
                          </strong>
                          <span>{item.noRegistrasi || "-"}</span>
                        </div>
                      </Col>
                      <Col md={6} className="mb-2">
                        <div className="d-flex">
                          <strong
                            className="mr-2"
                            style={{ minWidth: "140px" }}
                          >
                            Jumlah Masuk:
                          </strong>
                          <span>
                            {item.jumlahMasuk &&
                              numberWithCommas(item.jumlahMasuk)}{" "}
                            {item.satuan || ""}
                          </span>
                        </div>
                      </Col>
                      <Col md={6} className="mb-2">
                        <div className="d-flex">
                          <strong
                            className="mr-2"
                            style={{ minWidth: "140px" }}
                          >
                            Harga Satuan:
                          </strong>
                          <span>
                            Rp. {item.harga && numberWithCommas(item.harga)}
                          </span>
                        </div>
                      </Col>
                      <Col md={6} className="mb-2">
                        <div className="d-flex">
                          <strong
                            className="mr-2"
                            style={{ minWidth: "140px" }}
                          >
                            Total Harga:
                          </strong>
                          <span className="text-success font-weight-bold">
                            Rp.{" "}
                            {item.total_harga &&
                              numberWithCommas(item.total_harga)}
                          </span>
                        </div>
                      </Col>
                      <Col md={6} className="mb-2">
                        <div className="d-flex">
                          <strong
                            className="mr-2"
                            style={{ minWidth: "140px" }}
                          >
                            ED (Expired Date):
                          </strong>
                          <span>
                            {item.ed
                              ? new Date(item.ed).toLocaleDateString("id-ID")
                              : "-"}
                          </span>
                        </div>
                      </Col>
                      <Col md={6} className="mb-2">
                        <div className="d-flex">
                          <strong
                            className="mr-2"
                            style={{ minWidth: "140px" }}
                          >
                            Penyedia:
                          </strong>
                          <span>{item.penyedia || "-"}</span>
                        </div>
                      </Col>
                      <Col md={6} className="mb-2">
                        <div className="d-flex">
                          <strong
                            className="mr-2"
                            style={{ minWidth: "140px" }}
                          >
                            Total Keluar:
                          </strong>
                          <span className="text-warning">
                            {item.total_keluar &&
                              numberWithCommas(item.total_keluar)}{" "}
                            {item.satuan || ""}
                          </span>
                        </div>
                      </Col>
                      <Col md={6} className="mb-2">
                        <div className="d-flex">
                          <strong
                            className="mr-2"
                            style={{ minWidth: "140px" }}
                          >
                            Total Expired:
                          </strong>
                          <span className="text-danger font-weight-bold">
                            {item.total_expired
                              ? numberWithCommas(item.total_expired)
                              : "0"}{" "}
                            {item.satuan || ""}
                          </span>
                        </div>
                      </Col>
                      <Col md={6} className="mb-2">
                        <div className="d-flex">
                          <strong
                            className="mr-2"
                            style={{ minWidth: "140px" }}
                          >
                            Stok Sisa:
                          </strong>
                          <span className="text-primary font-weight-bold">
                            {item.stok_sisa && numberWithCommas(item.stok_sisa)}{" "}
                            {item.satuan || ""}
                          </span>
                        </div>
                      </Col>
                      <Col md={12} className="mt-2">
                        <div className="d-flex align-items-center">
                          <strong className="mr-2">Sumber:</strong>
                          <Badge color="secondary" className="mr-2">
                            {item.sumber || "-"}
                          </Badge>
                          <strong className="mr-2">Subsumber:</strong>
                          <Badge color="secondary">
                            {item.subsumber || "-"}
                          </Badge>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              ))}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => closeModalDetail()}>
            Tutup
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default TableNeracaMasukGudang_Gudang;
